module.exports = __webpack_public_path__ + "static/img/img20.9dabc82d.png";